module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Willkommen_BG.96a7bd8f.svg";